export let taxPlate = {
  namespaced:true,
  state:{
    taxNumber:0   // 差额数
  },
  mutations: {
    setTaxNumber(state, data) {
      state.taxNumber = data
    },
  },
}
